export default __webpack_public_path__ + "static/media/disclosures.65e29966.png";